
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { I18nMixin } from '../../mixins';
import WLNavbar from './WLNavbar.vue';
import WLBurgerMenu from './WLBurgerMenu.vue';
import WLBreadcrumb from '../WLBreadcrumb/WLBreadcrumb.vue';
import { NavLink, TopNavLink, IHeaderI18n, IHeaderOverrideI18n, ILogo } from './types';

@Component({
  components: { WLNavbar, WLBurgerMenu, WLBreadcrumb },
})
export default class WLHeader extends Mixins(I18nMixin) {
  public defaultI18n!: IHeaderI18n;

  @Prop()
  public overrideI18n!: IHeaderOverrideI18n;

  @Prop({ default: '+33170821769' })
  private phoneNumberCall?: string;

  @Prop()
  private navLinks?: NavLink[];

  @Prop()
  private topNavLinks?: TopNavLink[];

  @Prop()
  private logo!: ILogo | string;

  @Prop()
  private brandLogo!: ILogo | string;

  @Prop()
  private mobileLogo!: ILogo | string;

  @Prop({ default: 'MesBonsPros' })
  private title!: string;

  created() {
    this.defaultI18n = {
      nav_number: this.$t('components_plugin.navbar.phone_number'),
      nav_number_fees: this.$t('components_plugin.navbar.phone_fees'),
      nav_phone_number_link: this.$t('components_plugin.navbar.phone_number_link'),
    };
  }
}
